module.exports = __webpack_public_path__ + "img/ic_mine_sel.566da50e.svg";